import React from 'react';
import { NavLink } from 'react-router-dom';

class Header extends React.Component {
  render() {
    return (
      <header>
        <div className="logoBox showSmall">
          <NavLink className="logo" to="/">GORAH</NavLink>
        </div>
        <div className="navButtons">
          <NavLink className="logo hideSmall" to="/">GORAH</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/projects">Projects</NavLink>
          <NavLink to="/interviewsimulator">Interview Simulator</NavLink>
        </div>
      </header>
    )
  }
}

export default Header;
